import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient for the SPA.
 *
 * Lifted out of `main.tsx` so route loaders can call
 * `queryClient.ensureQueryData(...)` per apps/web/CLAUDE.md §5 — the
 * loader populates the cache, the route component reads from it with
 * `useSuspenseQuery`, no double-fetch.
 *
 * Defaults:
 *   - staleTime 30s (matches the convention default; per-query overrides
 *     where the data is hotter or colder).
 *   - refetchOnWindowFocus disabled — too noisy for an admin dashboard.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
